<template>
  <div class="randomiser-container">
    <div></div>
    <div class="randomiser-center-column">
      <div class="randomiser-header">
        Enter one player per line. <b>{{ `${playerCount}` }}</b> player/s
        entered.
      </div>
      <textarea
        name="randomise-players"
        id="random-player-list"
        class="randomiser-text-area"
        @input="randomCount = 0"
        v-model="playerNames"
        cols="30"
        rows="10"
      ></textarea>
      <!-- <label for="number-of-groups">Number of groups:</label>
    <input
      type="number"
      class="number-of-groups"
      id="number-of-groups"
      min="1"
      :max="numPlayers"
      v-model="numberGroups"
    /> -->
      <button @click="randomisePlayerList" class="button-6">
        <font-awesome-icon icon="fa fa-shuffle" class="shuffle-icon" />
      </button>
      <div class="randomise-count">
        {{ `Randomised ` }}
        <span
          ><strong>{{ randomCount }}</strong></span
        >
        {{ ` ${randomCount === 1 ? "time" : "times"} so far` }}
      </div>
    </div>
    <div class="randomiser-right-column">
      <button
        class="button-6 switch-randomiser-button"
        @click="toggleRandomiserMode"
      >
        <font-awesome-icon icon="fa fa-table-list" />
      </button>
      <div>Player Dropdown</div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "RandomisePlayers",
  data() {
    return {
      playerNames: "",
      randomCount: 0,
      // numberGroups: this.numPlayers,
    };
  },
  computed: {
    ...mapGetters(["getFilledSeats"]),
    playerCount() {
      return this.playerNames.split("\n").filter((x) => x !== "").length;
    },
  },
  methods: {
    ...mapActions(["setPlayerNames", "toggleRandomiserMode"]),
    randomisePlayerList() {
      const finalList = _.shuffle(
        this.playerNames.split("\n").filter((x) => x !== "")
      );
      const players = new Array(this.getFilledSeats);
      let pointer = 0;

      finalList.forEach((x) => {
        pointer = pointer % this.getFilledSeats;
        players[pointer] = players[pointer] ? `${players[pointer]}+${x}` : x;
        pointer++;
      });
      this.setPlayerNames(_.shuffle(players.map((x) => x.slice(0, 50))));
      this.randomCount++;
    },
  },
};
</script>

<style scoped>
.randomiser-center-column {
  margin-top: 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.randomiser-container {
  display: grid;
  grid-template-columns: 1fr 2fr 1fr;
}

.randomiser-right-column {
  text-align: left;
  padding: 20px;
  margin-top: 100px;
}

.randomiser-text-area {
  font-size: 16px;
  width: 400px;
  margin-top: 10px;
}

button {
  width: 100px;
  margin-top: 20px;
}

.randomise-count {
  margin-top: 10px;
}

.shuffle-icon {
  color: #666666;
}

.button-6 {
  align-items: center;
  background-color: #cccccc;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 0.25rem;
  box-shadow: rgba(0, 0, 0, 0.02) 0 1px 3px 0;
  box-sizing: border-box;
  cursor: pointer;
  font-family: Nunito, Arial, Helvetica, sans-serif;
  font-size: 24px;
  justify-content: center;
  line-height: 24px;
  min-height: 3rem;
  padding: calc(0.875rem - 1px) calc(1.5rem - 1px);
  position: relative;
  text-decoration: none;
  transition: all 250ms;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: baseline;
}

.button-6:hover:not([disabled]),
.button-6:focus:not([disabled]) {
  border-color: rgba(0, 0, 0, 0.15);
  box-shadow: rgba(0, 0, 0, 0.1) 0 4px 12px;
  color: rgba(0, 0, 0, 0.65);
}

.button-6:hover:not([disabled]) {
  transform: translateY(-1px);
}

.button-6:active {
  background-color: #f0f0f1;
  border-color: rgba(0, 0, 0, 0.15);
  box-shadow: rgba(0, 0, 0, 0.06) 0 2px 4px;
  color: rgba(0, 0, 0, 0.65);
  transform: translateY(0);
}

.button-6:disabled {
  background-color: #eeeeee;
  color: #888888;
}

.switch-randomiser-button {
  color: #666666;
}
</style>